/* Progressive quantity controls. Shopify's existing buy-box owns price/variant/cart. */
(function () {
  'use strict';
  function init(scope) {
    scope.querySelectorAll('[data-cof-purchase-quantity]').forEach(function (control) {
      if (control.dataset.cofPurchaseReady) return;
      var input = control.querySelector('input[name="quantity"]');
      var buttons = control.querySelectorAll('[data-cof-purchase-step]');
      if (!input || buttons.length !== 2) return;
      control.dataset.cofPurchaseReady = 'true';
      var min = Number(input.min) || 1;
      var max = Number(input.max) || 99;
      function value() {
        var n = parseInt(input.value, 10);
        return Math.max(min, Math.min(max, Number.isFinite(n) ? n : min));
      }
      function sync() {
        buttons.forEach(function (button) {
          button.disabled = input.disabled || (Number(button.dataset.cofPurchaseStep) < 0 ? value() <= min : value() >= max);
        });
      }
      buttons.forEach(function (button) {
        button.hidden = false;
        button.addEventListener('click', function () {
          if (button.disabled || input.disabled) return;
          input.value = String(Math.max(min, Math.min(max, value() + Number(button.dataset.cofPurchaseStep))));
          input.dispatchEvent(new Event('input', { bubbles: true }));
          input.dispatchEvent(new Event('change', { bubbles: true }));
          sync();
        });
      });
      input.addEventListener('input', sync);
      input.addEventListener('change', sync);
      sync();
    });
  }
  init(document);
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
})();
